var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5C68C00F-8782-4F6F-A312-437AC1310438") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "questionnaire--Contact-information-eror",
    transform: "translate(-988.000000, -381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "safe",
    transform: "translate(989.000000, 382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Obligation-Copy",
    fillRule: "nonzero",
    stroke: "#617984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart;-action;-shop;-store;-buy;-check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4188369,-0.5 C24.1191871,-0.5 31.1966147,6.57742763 31.1966147,15.2777778 C31.1966147,23.9781279 24.1191871,31.0555556 15.4188369,31.0555556 C6.71848679,31.0555556 -0.358940833,23.9781279 -0.358940833,15.2777778 C-0.358940833,6.57742753 6.71848661,-0.5 15.4188369,-0.5 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.2391304,19.0065815 L15.2391304,20.0414885 C15.2391304,20.4790699 15.5794412,20.8331552 16,20.8331552 C16.4205588,20.8331552 16.7608696,20.4790699 16.7608696,20.0414885 L16.7608696,19.0065815 C17.2073417,18.730194 17.5217391,18.2449695 17.5217391,17.6664885 C17.5217391,16.7936452 16.8396314,16.0831552 16,16.0831552 C15.1603686,16.0831552 14.4782609,16.7936452 14.4782609,17.6664885 C14.4782609,18.2449695 14.7926583,18.7301939 15.2391304,19.0065815 Z",
    id: "Path",
    fill: "#617984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8478261,23.9998219 L9.15217391,23.9998219 L9.15217391,12.9164885 L9.15068778,12.9164885 L9.15217391,12.9164885 L22.8478261,12.9164885 L22.8478261,23.9998219 Z M21.326087,11.3331552 L10.673913,11.3331552 L10.673913,10.5414885 C10.673913,7.48615 13.063519,4.99982188 16,4.99982188 C18.936481,4.99982188 21.326087,7.48615 21.326087,10.5414885 L21.326087,11.3331552 Z",
    id: "Shape",
    stroke: "#617984",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a584cbf3e69b822ebeec285e1707dbf3.svg";
export { ForwardRef as ReactComponent };